const productData = [
  {
    name: "ValueMedi",
    website: "https://valuemedi.com/home"
  },
  {
    name: "ValueSale",
    website: "https://valuesale.in/home"
  },
  {
    name: "WMS",
    website: "https://wms-staging.enneasolutions.com/home"
  },
  {
    name: "ValueMRP",
    website: "https://valuemrp.com/home/"
  },
  {
    name: "PatharDekho",
    website: "https://pathardekho.com/"
  }
];

export default productData;
